const imgUrl = window.location.origin+"/files/images/schemes-music/";
const audioUrl = window.location.origin+"/files/audios/schemes-music/";

const singles = [
    {id: 1, title: "Propaganda cover", artist: "Rhymecity", cover: imgUrl+"5.jpg", album: null, dl:  audioUrl+"Rhymecity - Propaganda (cover).mp3"},
    {id: 2, title: "Respekt", artist: "Rhymecity", cover: imgUrl+"8.jpg", album: null, dl:  audioUrl+"Rhymecity - Respekt.mp3"},
    {id: 3, title: "Rhymecity ft Rachael Chie - I'll be there with you", artist: "Rhymecity", cover: imgUrl+"3.jpg", album: null, dl:  audioUrl+"Rhymecity ft Rachael Chie - I'll be there with you (Inspired by Lwam).mp3"},
    {id: 4, title: "Present is Bleak", artist: "Rhymecity", cover: imgUrl+"9.jpg", album: null, dl: audioUrl+"Rhymecity - Present is Bleak (Prod by Ralph).mp3"}
];

const eps = [];

const lps = [];

// ALBUMS

const albums = [
    // {id: 1, title: "Can you keep up", artist: "Rhymecity",  cover: imgUrl+"4.jpg", album: "Hip-Hop Heads"},
    // {id: 2, title: "Evil ft Ralph", artist: "Rhymecity",  cover: imgUrl+"4.jpg", album: "Hip-Hop Heads"},
    // {id: 3, title: "Nonstop ft One line Massacre", artist: "Rhymecity",  cover: imgUrl+"4.jpg", album: "Hip-Hop Heads"},
    // {id: 4, title: "Dope", artist: "Rhymecity",  cover: imgUrl+"5.jpg", album: "Trap Season"},
    // {id: 5, title: "Trap House", artist: "Rhymecity",  cover: imgUrl+"5.jpg", album: "Trap Season"},
    // {id: 6, title: "Barbie Doll ft Rachael Chie",  artist: "Rhymecity", cover: imgUrl+"5.jpg", album: "Trap Season"},
    // {id: 7, title: "Spazzed Out", artist: "Rhymecity", cover: imgUrl+"6.jpg", album: "Spazzed Out"},
    // {id: 8, title: "Run run run", artist: "Rhymecity",  cover: imgUrl+"6.jpg", album: "Spazzed Out"},
    // {id: 9, title: "Venom ft Reno Reigns", artist: "Rhymecity",  cover: imgUrl+"6.jpg", album: "Spazzed Out"}

];













export { singles, eps, lps, albums, imgUrl }